import React, { useState } from "react";
import { X, ChevronRight, Database, Globe, RefreshCw } from "lucide-react";

/** Matches .lov-catalog-root --catalog-navy-bg (inherits when modal is under catalog) */
const CATALOG_NAVY_BG = "var(--catalog-navy-bg, rgba(33, 55, 97, 0.85))";

const DATABASES = [
  { value: "bonsai", label: "Bonsai", price: "Gratis", desc: "Begrænset men gratis grunddatabase" },
  { value: "idemat", label: "Idemat", price: "550 DKK/år", desc: "Bred dækning, god datakvalitet" },
  { value: "ecoinvent", label: "Ecoinvent", price: "15.000 DKK/år", desc: "Brancheledende, højeste datakvalitet" },
];

export function IdematPaymentDialog({ onConfirm, onClose }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm" style={{ zIndex: 300 }}>
      <div className="rounded-2xl shadow-2xl p-6 w-[420px] space-y-5" style={{ backgroundColor: "var(--card-bg,#fff)", border: "1px solid var(--border,#e5e7eb)" }}>
        <div className="flex items-center justify-between">
          <h3 className="text-base font-semibold">Køb Idemat Licens</h3>
          <button type="button" onClick={onClose} style={{ color: "#6b7280" }}>
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="rounded-xl p-4 text-center space-y-1" style={{ background: "rgba(59, 130, 246, 0.08)", border: "1px solid rgba(59, 130, 246, 0.2)" }}>
          <p className="text-3xl font-bold" style={{ color: "hsl(221 39% 24%)" }}>550 DKK</p>
          <p className="text-xs text-muted-foreground" style={{ color: "#6b7280" }}>Årsabonnement pr. bruger</p>
        </div>
        <ul className="space-y-1.5 text-sm" style={{ color: "#6b7280", listStyle: "none", padding: 0 }}>
          <li>✓ Fuld adgang til Idemat-databasen</li>
          <li>✓ Regelmæssige dataopdateringer</li>
          <li>✓ Teknisk support inkluderet</li>
          <li>✓ Gælder for alle produkter, projekter og tjenester</li>
          <li>✓ Gyldigt 12 måneder</li>
        </ul>
        <div className="flex justify-end gap-2 pt-1">
          <button type="button" onClick={onClose} className="rounded-md border px-3 py-1.5 text-sm" style={{ border: "1px solid #e5e7eb" }}>Annuller</button>
          <button type="button" onClick={onConfirm} className="rounded-md px-3 py-1.5 text-sm text-white" style={{ background: CATALOG_NAVY_BG }}>Gennemfør betaling</button>
        </div>
      </div>
    </div>
  );
}

export function EcoinventLicenseDialog({ onActivate, onPurchase, onClose }) {
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm" style={{ zIndex: 300 }}>
      <div className="rounded-2xl shadow-2xl p-6 w-[440px] space-y-5" style={{ backgroundColor: "var(--card-bg,#fff)", border: "1px solid var(--border,#e5e7eb)" }}>
        <div className="flex items-center justify-between">
          <h3 className="text-base font-semibold">Ecoinvent Adgang</h3>
          <button type="button" onClick={onClose} style={{ color: "#6b7280" }}>
            <X className="h-4 w-4" />
          </button>
        </div>
        <p className="text-xs text-muted-foreground" style={{ color: "#6b7280" }}>
          Indtast din eksisterende licens eller køb en ny. Licensen gælder for alle produkter, projekter og tjenester.
        </p>
        <div className="space-y-3">
          {[
            { id: "ec-code", label: "Licensnøgle", placeholder: "Fx EC-XXXX-XXXX-XXXX", val: code, set: setCode },
            { id: "ec-email", label: "E-mail", placeholder: "din@email.com", val: email, set: setEmail },
            { id: "ec-user", label: "Brugernavn", placeholder: "Dit brugernavn", val: username, set: setUsername },
          ].map((f) => (
            <div key={f.id} style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label htmlFor={f.id} className="text-xs font-medium" style={{ color: "#6b7280" }}>{f.label}</label>
              <input
                id={f.id}
                value={f.val}
                onChange={(e) => f.set(e.target.value)}
                placeholder={f.placeholder}
                className="w-full h-9 rounded-lg border px-3 text-sm"
                style={{ borderColor: "#e5e7eb" }}
              />
            </div>
          ))}
        </div>
        <div className="relative flex items-center gap-3">
          <div className="flex-1 h-px" style={{ background: "#e5e7eb" }} />
          <span className="text-xs uppercase" style={{ color: "#6b7280" }}>eller</span>
          <div className="flex-1 h-px" style={{ background: "#e5e7eb" }} />
        </div>
        <div className="flex flex-col gap-2">
          <button
            type="button"
            disabled={!code || !email || !username}
            onClick={onActivate}
            className="w-full rounded-md py-2 text-sm text-white disabled:opacity-50"
            style={{ background: CATALOG_NAVY_BG }}
          >
            Aktivér licens
          </button>
          <button type="button" onClick={onPurchase} className="w-full rounded-md border py-2 text-sm" style={{ border: "1px solid #e5e7eb" }}>
            Køb ny licens (15.000 DKK) <span className="text-[10px] ml-1" style={{ color: "#6b7280" }}>Coming soon</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export function EcoinventPaymentDialog({ onConfirm, onClose }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm" style={{ zIndex: 300 }}>
      <div className="rounded-2xl shadow-2xl p-6 w-[420px] space-y-5" style={{ backgroundColor: "var(--card-bg,#fff)", border: "1px solid var(--border,#e5e7eb)" }}>
        <div className="flex items-center justify-between">
          <h3 className="text-base font-semibold">Køb Ecoinvent Licens</h3>
          <button type="button" onClick={onClose} style={{ color: "#6b7280" }}>
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="rounded-xl p-4 text-center space-y-1" style={{ background: "rgba(245, 158, 11, 0.1)", border: "1px solid rgba(245, 158, 11, 0.3)" }}>
          <p className="text-3xl font-bold" style={{ color: "#d97706" }}>15.000 DKK</p>
          <p className="text-xs text-muted-foreground" style={{ color: "#6b7280" }}>Årsabonnement pr. bruger</p>
        </div>
        <ul className="space-y-1.5 text-sm" style={{ color: "#6b7280", listStyle: "none", padding: 0 }}>
          <li>✓ Komplet Ecoinvent-database adgang</li>
          <li>✓ Højeste datakvalitet og pålidelighed</li>
          <li>✓ Global geografisk dækning</li>
          <li>✓ Prioriteret teknisk support</li>
          <li>✓ Gælder for alle produkter, projekter og tjenester</li>
          <li>✓ Gyldigt 12 måneder</li>
        </ul>
        <div className="flex justify-end gap-2 pt-1">
          <button type="button" onClick={onClose} className="rounded-md border px-3 py-1.5 text-sm" style={{ border: "1px solid #e5e7eb" }}>Annuller</button>
          <button type="button" onClick={onConfirm} className="rounded-md px-3 py-1.5 text-sm text-white" style={{ background: "#d97706" }}>Gennemfør betaling</button>
        </div>
      </div>
    </div>
  );
}

export function CalculationSetupDialog({ formData, year, chosenSubgroup, onCreateProduct, onClose }) {
  const [selectedStandard, setSelectedStandard] = useState("");
  const [selectedDb, setSelectedDb] = useState("bonsai");
  const [step, setStep] = useState("setup");

  const needsIdematPayment = selectedDb === "idemat";
  const needsEcoinventSetup = selectedDb === "ecoinvent";
  const requiresAction = needsIdematPayment || needsEcoinventSetup;

  const handleSelectStandard = (std) => {
    setSelectedStandard(std);
    if (std === "PCF_GHG") {
      onCreateProduct({ ...formData, assessment_type: "PCF", database: "bonsai" });
      onClose();
    }
  };

  const handleConfirmDb = () => {
    if (needsIdematPayment) {
      setStep("idemat-pay");
    } else if (needsEcoinventSetup) {
      setStep("ecoinvent-license");
    } else {
      doCreateProduct();
      onClose();
    }
  };

  const doCreateProduct = () => {
    const assessmentType = selectedStandard === "PCF_GHG" ? "PCF" : "LCA";
    onCreateProduct({
      ...formData,
      assessment_type: assessmentType,
      database: selectedDb,
    });
  };

  if (step === "idemat-pay") {
    return (
      <IdematPaymentDialog
        onConfirm={() => {
          doCreateProduct();
          onClose();
        }}
        onClose={() => setStep("setup")}
      />
    );
  }

  if (step === "ecoinvent-license") {
    return (
      <EcoinventLicenseDialog
        onActivate={() => {
          doCreateProduct();
          onClose();
        }}
        onPurchase={() => setStep("ecoinvent-pay")}
        onClose={() => setStep("setup")}
      />
    );
  }

  if (step === "ecoinvent-pay") {
    return (
      <EcoinventPaymentDialog
        onConfirm={() => {
          doCreateProduct();
          onClose();
        }}
        onClose={() => setStep("ecoinvent-license")}
      />
    );
  }

  if (!selectedStandard) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4" style={{ zIndex: 200 }}>
        <div className="rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden" style={{ backgroundColor: "var(--card-bg,#fff)", border: "1px solid var(--border,#e5e7eb)" }}>
          <div className="px-8 py-6 flex flex-col gap-1" style={{ background: CATALOG_NAVY_BG }}>
            <h2 className="text-lg font-bold text-white">Compile your product impact</h2>
            <p className="text-sm text-white/60">Choose your assessment methodology to get started</p>
          </div>

          <div className="p-8" style={{ padding: "32px" }}>
            <div className="grid grid-cols-2 gap-5" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
              <button
                type="button"
                onClick={() => handleSelectStandard("PCF_GHG")}
                className="text-left flex flex-col gap-4 p-6 rounded-xl border transition-all duration-150 hover:border-primary hover:shadow-md"
                style={{ border: "1px solid #e5e7eb", background: "var(--card-bg,#fff)", padding: "24px" }}
              >
                <div className="w-12 h-12 rounded-xl bg-muted flex items-center justify-center" style={{ background: "rgba(0,0,0,0.06)", width: "48px", height: "48px" }}>
                  <Globe className="h-6 w-6 text-foreground" />
                </div>
                <div className="space-y-1.5">
                  <p className="text-base font-bold">Product Carbon Footprint</p>
                  <p className="text-sm text-muted-foreground leading-relaxed" style={{ color: "#6b7280" }}>
                    Calculate carbon emissions following the GHG Protocol standards
                  </p>
                </div>
                <ul className="space-y-1.5 text-sm text-muted-foreground" style={{ color: "#6b7280", listStyle: "none", padding: 0 }}>
                  <li>✓ Focused on greenhouse gas emissions</li>
                  <li>✓ GHG Protocol methodology</li>
                  <li>✓ Scope 1, 2, and 3 emissions tracking</li>
                  <li>✓ Faster assessment process</li>
                </ul>
                <div className="mt-auto w-full rounded-lg py-2.5 text-center text-sm font-semibold text-white" style={{ background: CATALOG_NAVY_BG }}>
                  Start PCF Assessment
                </div>
              </button>

              <button
                type="button"
                onClick={() => handleSelectStandard("EN15804_GENERIC")}
                className="text-left flex flex-col gap-4 p-6 rounded-xl border transition-all duration-150 hover:border-primary hover:shadow-md"
                style={{ border: "1px solid #e5e7eb", background: "var(--card-bg,#fff)", padding: "24px" }}
              >
                <div className="w-12 h-12 rounded-xl bg-muted flex items-center justify-center" style={{ background: "rgba(0,0,0,0.06)", width: "48px", height: "48px" }}>
                  <RefreshCw className="h-6 w-6 text-foreground" />
                </div>
                <div className="space-y-1.5">
                  <p className="text-base font-bold">Life Cycle Assessment</p>
                  <p className="text-sm text-muted-foreground leading-relaxed" style={{ color: "#6b7280" }}>
                    Comprehensive environmental impact analysis following ISO 14040/44
                  </p>
                </div>
                <ul className="space-y-1.5 text-sm text-muted-foreground" style={{ color: "#6b7280", listStyle: "none", padding: 0 }}>
                  <li>✓ Full cradle-to-grave analysis</li>
                  <li>✓ ISO 14040/44 compliant</li>
                  <li>✓ Multiple environmental indicators</li>
                  <li>✓ Detailed impact assessment</li>
                </ul>
                <div className="mt-auto w-full rounded-lg py-2.5 text-center text-sm font-semibold text-white" style={{ background: CATALOG_NAVY_BG }}>
                  Start LCA Assessment
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const confirmLabel = requiresAction
    ? selectedDb === "idemat"
      ? "Fortsæt til betaling →"
      : "Fortsæt til licensaktivering →"
    : "Bekræft valg";

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4" style={{ zIndex: 200 }}>
      <div className="rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden" style={{ backgroundColor: "var(--card-bg,#fff)", border: "1px solid var(--border,#e5e7eb)" }}>
        <div className="px-6 py-5 flex flex-col gap-1" style={{ background: CATALOG_NAVY_BG, padding: "20px 24px" }}>
          <div className="flex items-center justify-between">
            <h2 className="text-base font-bold text-white">Opsæt din beregning</h2>
            <button
              type="button"
              onClick={() => setSelectedStandard("")}
              className="text-white/50 hover:text-white/80 text-xs underline underline-offset-2"
            >
              ← Skift standard
            </button>
          </div>
          <p className="text-xs text-white/60 leading-relaxed">
            Produktet er oprettet. Vælg beregningsstandard og database – du kan altid ændre det via dropdowns i produktheaderen.
          </p>
        </div>

        <div className="p-6 space-y-4" style={{ padding: "24px" }}>
          <div className="flex items-center gap-2">
            <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: "#6b7280" }}>Standard:</span>
            <span className="text-xs font-medium px-2.5 py-1 rounded-full border" style={{ background: "rgba(59, 130, 246, 0.1)", color: "hsl(221 39% 24%)", border: "1px solid rgba(59, 130, 246, 0.2)" }}>
              {selectedStandard === "PCF_GHG" ? "Product Carbon Footprint (GHG)" : "LCA (EN 15804 +A2)"}
            </span>
          </div>

          <div className="space-y-2">
            <p className="text-xs font-semibold uppercase tracking-wider flex items-center gap-1.5" style={{ color: "#6b7280" }}>
              <Database className="h-3.5 w-3.5" /> Database
            </p>
            <div className="grid grid-cols-3 gap-2" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "8px" }}>
              {DATABASES.map((db) => (
                <button
                  key={db.value}
                  type="button"
                  onClick={() => setSelectedDb(db.value)}
                  className="text-left flex flex-col gap-1 px-3 py-3 rounded-xl border transition-all duration-150"
                  style={{
                    border: selectedDb === db.value ? "1px solid hsl(221 39% 24%)" : "1px solid #e5e7eb",
                    background: selectedDb === db.value ? "rgba(59, 130, 246, 0.08)" : "rgba(0,0,0,0.02)",
                    padding: "12px",
                  }}
                >
                  <p className="text-xs font-semibold">{db.label}</p>
                  <p
                    className="text-[10px] font-medium"
                    style={{
                      color: db.value === "bonsai" ? "#059669" : db.value === "ecoinvent" ? "#d97706" : "hsl(221 39% 24%)",
                    }}
                  >
                    {db.price}
                  </p>
                  <p className="text-[10px] leading-tight" style={{ color: "#6b7280" }}>{db.desc}</p>
                </button>
              ))}
            </div>

            <p
              className="text-[11px] font-medium pt-1"
              style={{ color: !requiresAction && selectedDb === "bonsai" ? "#059669" : requiresAction ? "#d97706" : "#059669" }}
            >
              {!requiresAction && selectedDb === "bonsai" && "✓ Bonsai er gratis – ingen betaling kræves."}
              {!requiresAction && selectedDb !== "bonsai" && `✓ Din ${selectedDb}-licens dækker dette produkt.`}
              {needsIdematPayment && "Idemat kræver et årsabonnement på 550 DKK."}
              {needsEcoinventSetup && "Ecoinvent kræver licensaktivering eller køb (15.000 DKK/år)."}
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-2 px-6 py-4 border-t border-border" style={{ padding: "16px 24px", borderTop: "1px solid #e5e7eb" }}>
          <button
            type="button"
            onClick={handleConfirmDb}
            className="rounded-md px-3 py-1.5 text-sm text-white flex items-center gap-1.5"
            style={{ background: CATALOG_NAVY_BG }}
          >
            {confirmLabel} {!requiresAction && <ChevronRight className="h-3.5 w-3.5" />}
          </button>
        </div>
      </div>
    </div>
  );
}
